var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48535 20.4459V14.5542",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6147 25.3457H8.3855",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5146 14.5542V20.4459",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3855 9.6543H26.6147",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38539 9.6543C8.38924 10.3002 8.26533 10.9405 8.02081 11.5384C7.77628 12.1363 7.41596 12.6799 6.96057 13.138C6.50518 13.5961 5.96371 13.9596 5.3673 14.2077C4.7709 14.4558 4.13133 14.5835 3.48539 14.5835V12.3668C3.48347 12.0113 3.55183 11.6589 3.68656 11.3299C3.82128 11.0009 4.0197 10.7017 4.27042 10.4496C4.52113 10.1976 4.8192 9.99754 5.14748 9.86105C5.47576 9.72456 5.82778 9.65429 6.18331 9.6543H8.38539Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38539 25.3457H6.18331C5.82778 25.3457 5.47576 25.2754 5.14748 25.1389C4.8192 25.0024 4.52113 24.8024 4.27042 24.5503C4.0197 24.2983 3.82128 23.9991 3.68656 23.6701C3.55183 23.3411 3.48347 22.9887 3.48539 22.6332V20.4165C4.13133 20.4165 4.7709 20.5442 5.3673 20.7923C5.96371 21.0403 6.50518 21.4039 6.96057 21.862C7.41596 22.3201 7.77628 22.8637 8.02081 23.4616C8.26533 24.0594 8.38924 24.6997 8.38539 25.3457Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5145 20.4165V22.604C31.5145 23.3234 31.2287 24.0134 30.72 24.5221C30.2114 25.0307 29.5214 25.3165 28.802 25.3165H26.6145C26.6126 24.6725 26.738 24.0345 26.9836 23.4391C27.2292 22.8437 27.59 22.3028 28.0454 21.8474C28.5008 21.392 29.0417 21.0312 29.6371 20.7856C30.2325 20.54 30.8705 20.4146 31.5145 20.4165Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5145 12.3664V14.5831C30.8705 14.585 30.2325 14.4596 29.6371 14.214C29.0417 13.9685 28.5008 13.6076 28.0454 13.1522C27.59 12.6968 27.2292 12.1559 26.9836 11.5605C26.738 10.9652 26.6126 10.3271 26.6145 9.68311H28.802C29.5164 9.68306 30.2019 9.96484 30.7098 10.4672C31.2177 10.9696 31.5068 11.6521 31.5145 12.3664Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.9209V13.8251",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.1748V22.079",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 17.5874C17.9757 17.5874 18.4319 17.7764 18.7683 18.1128C19.1047 18.4492 19.2937 18.9054 19.2937 19.3812C19.2937 19.8569 19.1047 20.3131 18.7683 20.6495C18.4319 20.9859 17.9757 21.1749 17.4999 21.1749C17.1876 21.1715 16.8815 21.0878 16.6108 20.9321C16.3401 20.7763 16.114 20.5536 15.9541 20.2853",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5875C17.2518 17.61 17.0017 17.5805 16.7656 17.5009C16.5294 17.4213 16.3125 17.2934 16.1285 17.1253C15.9446 16.9573 15.7976 16.7527 15.6971 16.5247C15.5966 16.2967 15.5447 16.0503 15.5447 15.8011C15.5447 15.5519 15.5966 15.3054 15.6971 15.0774C15.7976 14.8494 15.9446 14.6449 16.1285 14.4768C16.3125 14.3087 16.5294 14.1808 16.7656 14.1013C17.0017 14.0217 17.2518 13.9922 17.5 14.0146C17.7855 14.018 18.0662 14.0884 18.3195 14.2201C18.5728 14.3518 18.7916 14.5412 18.9583 14.773",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2563 29.6626H8.40002C8.14043 29.6619 7.88862 29.7512 7.68744 29.9153C7.48625 30.0793 7.34813 30.308 7.29655 30.5624C7.24498 30.8169 7.28315 31.0813 7.40457 31.3107C7.52599 31.5402 7.72316 31.7205 7.96252 31.8209L10.2959 32.8126",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74365 5.3375H26.5999C26.8595 5.33818 27.1113 5.24889 27.3125 5.08484C27.5137 4.92078 27.6518 4.69209 27.7034 4.43767C27.7549 4.18325 27.7168 3.91882 27.5954 3.68937C27.4739 3.45992 27.2768 3.27963 27.0374 3.17917L24.7041 2.1875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTransfer);
export default __webpack_public_path__ + "static/media/moneyTransfer.3800dcf509943f16df3197f70869f014.svg";
export { ForwardRef as ReactComponent };